/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Texture } from 'pixi.js-legacy';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { TicketContainer, TICKET_CHANGE_EVENTS } from '@appPlanApplication/tickets/TicketContainer';
import { TicketMeshComponent } from './TicketMeshComponent';
import { Ticket } from '@touchplan/common';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { setTicketWidthHelper } from 'src/app/utils/ticket-utils';

export enum TASK_SHADDOW_SETTINGS {
	LEFT_OFFSET = 42,
	TOP_OFFSET = 42,
}

export class TaskShadowMesh extends TicketMeshComponent implements ComponentInterface {
	constructor(texture: Texture, canvasAngularLand: CanvasAngularLand, ticketContainer: TicketContainer) {
		super(texture, canvasAngularLand, ticketContainer, 61, 58, 61, 58);

		ticketContainer.on(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);

		// In the ticket shadow texture, the ticket shape is offset 10-pixels from the top-left. This is to factor in the
		// "shadow" in the texture. So we offset the image 10-pixels when we draw so it all aligns neatly.
		this.x = -10;
		this.y = -10;

		this.alpha = 0.25;

		this.onChanged(ticketContainer);
	}

	private isDirty(newWidth: number, newHeight: number): boolean {
		return this.height !== newHeight || this.width !== newWidth;
	}

	private onChanged = (ticketContainer: TicketContainer) => {
		const data: Ticket = ticketContainer.getData();
		const layout = ticketContainer.getLayout();
		const width = setTicketWidthHelper(data, layout, this.canvasAngularLand.wideTicketSize$.getValue());
		const newWidth = width + TASK_SHADDOW_SETTINGS.LEFT_OFFSET;
		const newHeight = layout.height + TASK_SHADDOW_SETTINGS.TOP_OFFSET;
		if (this.visible && this.isDirty(newWidth, newHeight)) {
			this.width = newWidth;
			this.height = newHeight;
		}
	};

	public update(canvasAngularLand: CanvasAngularLand, ticketContainer: TicketContainer) {
		const data: Ticket = ticketContainer.getData();
		const layout = ticketContainer.getLayout();
		const width = setTicketWidthHelper(data, layout, this.canvasAngularLand.wideTicketSize$.getValue());
		const newWidth = width + TASK_SHADDOW_SETTINGS.LEFT_OFFSET;
		const newHeight = layout.height + TASK_SHADDOW_SETTINGS.TOP_OFFSET;
		if (this.visible && this.isDirty(newWidth, newHeight)) {
			this.width = newWidth;
			this.height = newHeight;
		}
	}

	public override destroy(options?) {
		this.ticket.off(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);
		super.destroy(options);
	}
}
